// i18n
import "src/locales/i18n";

// scroll bar
import "simplebar-react/dist/simplebar.min.css";

// lightbox
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

// editor
import "react-quill/dist/quill.snow.css";

// slick-carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// lazy image
import "react-lazy-load-image-component/src/effects/blur.css";

// redux
import ReduxProvider from "src/redux/redux-provider";
// routes
import Router from "src/routes/sections";
// theme
import ThemeProvider from "src/theme";
// tour
import TourProvider from "src/tour";
// hooks
import { useScrollToTop } from "src/hooks/use-scroll-to-top";
// components
import ProgressBar from "src/components/progress-bar";
import MotionLazy from "src/components/animate/motion-lazy";
import SnackbarProvider from "src/components/snackbar/snackbar-provider";
import { SettingsProvider, SettingsDrawer } from "src/components/settings";
// auth
import { AuthProvider, AuthConsumer } from "src/auth/context/jwt";
//
import { SWRConfig } from "swr";
import { HistoryConfigurator } from "./utils/history";

// ----------------------------------------------------------------------

export default function App() {
  useScrollToTop();

  return (
    <SWRConfig
      value={{
        revalidateOnFocus: false,
      }}
    >
      <AuthProvider>
        <ReduxProvider>
          <SettingsProvider>
            <ThemeProvider>
              <MotionLazy>
                <SnackbarProvider>
                  <TourProvider>
                    <SettingsDrawer />
                    <ProgressBar />
                    <HistoryConfigurator />
                    <AuthConsumer>
                      <Router />
                    </AuthConsumer>
                  </TourProvider>
                </SnackbarProvider>
              </MotionLazy>
            </ThemeProvider>
          </SettingsProvider>
        </ReduxProvider>
      </AuthProvider>
    </SWRConfig>
  );
}
